import s from './MineFriends.module.sass';
import React, { FC, useEffect, useLayoutEffect, useMemo, useState } from 'react';
import {
  Button,
  Header,
  InlineHeader,
  List,
  ListItem,
  LottieIcon,
  Placeholder,
  ScrollView,
} from '$uikit';
import { LoadingStatus } from '$store/reels/interface';
import { MineFriend } from '$store/models';
import { Api } from '$api';
import { useDispatch } from 'react-redux';
import { toastActions } from '$store/toast';
import { mainActions } from '$store/main';
import { batchActions } from '$store';
import { Loader, UserCell } from '$shared/components';
import { useCurrentUserInfo, useTranslator } from '$hooks';
import copyToClipboard from 'copy-text-to-clipboard';
import { formatBigNumber } from '$utils';

export const MineFriends: FC = () => {
  const t = useTranslator();
  const dispatch = useDispatch();
  const [loadingStatus, setLoadingStatus] = useState<LoadingStatus>('loading');
  const [info, setInfo] = useState<{
    items: MineFriend[];
  } | null>(null);
  const curUser = useCurrentUserInfo();

  const loadData = () => {
    setLoadingStatus('loading');
    Api.get<any, any>('/mine/friends')
      .then((resp) => {
        dispatch(mainActions.setUsers(resp.users));
        setInfo(resp);
        setLoadingStatus('');
      })
      .catch((e) => {
        dispatch(toastActions.setToastFail(e.message));
        setLoadingStatus('failed');
      });
  };

  useLayoutEffect(() => {
    loadData();
  }, []);

  const hexId = useMemo(() => {
    if (!curUser) {
      return '';
    }

    return new Number(curUser.id).toString(16);
  }, [curUser]);

  const handleCopy = () => {
    copyToClipboard(`https://ton.place/mine/top?ref=${hexId}`);
    dispatch(toastActions.setToastSuccess(t('copied')));
  };

  function renderContent() {
    if (loadingStatus === 'failed') {
      return (
        <Placeholder
          title={t('failed_title')}
          actions={<Button onClick={loadData}>{t('failed_button')}</Button>}
        >
          {t('failed_caption')}
        </Placeholder>
      );
    }

    if (loadingStatus === 'loading' || !info) {
      return <Loader isWrapped />;
    }

    return (
      <>
        <Placeholder
          iconSize={120}
          icon={<LottieIcon name="duck_social_out" loop />}
          compact
          title="Invite Friends and Reap Big Rewards!"
        >
          Earn 50% of Your Friend`s Earnings for a Whole Month! Example: If your friend
          earns 100 coins, you`ll receive 50 coins as a bonus. The more friends you
          invite, the more you can earn!
        </Placeholder>
        <div className={s.linkWrap}>
          <List title="Your referral link">
            <ListItem>ton.place/mine/top?ref={hexId}</ListItem>
            <ListItem color="green" onClick={handleCopy}>
              Copy Link
            </ListItem>
          </List>
        </div>
        <InlineHeader>Friends</InlineHeader>
        {info.items.length === 0 && (
          <Placeholder compact>You haven`t invited anyone</Placeholder>
        )}
        {info.items.map((item) => (
          <UserCell
            key={item.userId}
            objectId={item.userId}
            isFollowBtnShown={false}
            disabled
            skipButton
            after={<div className={s.earned}>+{formatBigNumber(item.coins)}</div>}
          />
        ))}
      </>
    );
  }

  return (
    <>
      <Header showBackButton>Friends</Header>
      <ScrollView>{renderContent()}</ScrollView>
    </>
  );
};
